module.exports = __webpack_public_path__ + "img/title_bglf.ac01944a.png";